import { superUserService } from "@/services/SuperUserService";
import { toast } from "vue3-toastify";
import { i18n } from "./../lang";

const state = {
    superUsers: [],
    isLoadingRequest: false,
    editingSuperUser: null,
    editRequest: {
        loading: false,
    },
    isAddingSuperUser: false,
    addRequest: {
        loading: false,
    },
    regenerateRequest: {
        loading: false,
    }
};

const actions = {
    getAllSuperUsers({ commit }){
        commit(mutations.setLoadingRequest.name, true);
        superUserService.getAllSuperUsers()
            .then((response) => {
                commit(mutations.setLoadingRequest.name, false);
                commit(mutations.setSuperUsersList.name, response.data);
            })
            .catch(() => {
                commit(mutations.setLoadingRequest.name, false);
            });
    },
    createSuperUser({ commit }, payload){
        commit(mutations.setAddSuperUserRequestState.name, { loading: true });
        superUserService.createSuperUser(payload)
            .then((response) => {
                toast.success(i18n.global.t("toast.createSuccess"));
                commit(mutations.setAddSuperUserRequestState.name, { loading: false });
                commit(mutations.addNewSuperUser.name, response.data ?? response);
            })
            .catch((error) => {
                toast.error(error);
                commit(mutations.setAddSuperUserRequestState.name, { loading: false, message: error });
            });
    },
    updateSuperUser({ commit, state }, { userId, payload }){
        commit(mutations.setSuperUserEditRequestStarted.name);
        superUserService.updateSuperUser(userId, payload)
            .then((response) => {
                toast.success(i18n.global.t("toast.successEdit"));
                const updatedSuperUser = response.data ?? response;
                const updatedSuperUsers = state.superUsers.map(x => (x.userId === userId ? updatedSuperUser : x));
                commit(mutations.setEditRequestSuccess.name);
                commit(mutations.updateSuperUsersList.name, updatedSuperUsers);
            })
            .catch((error) => {
                toast.error(error);
                commit(mutations.setEditRequestError.name, error);
            });
    },
    regeneratePassword({ commit }, userId){
        commit(mutations.setRegenerateRequest.name, { loading: true });
        superUserService.regeneratePassword(userId)
            .then(() => {
                toast.success(i18n.global.t("toast.successEdit"));
                commit(mutations.setRegenerateRequest.name, { loading: false });
            })
            .catch((error) => {
                toast.error(error);
                commit(mutations.setRegenerateRequest.name, { loading: false, message: error });
            });
    },
    deleteSuperUser({ commit, state }, superUser){
        commit(mutations.setSuperUserEditRequestStarted.name);
        superUserService.deleteSuperUser(superUser.userId)
            .then(() => {
                toast.success(i18n.global.t("toast.deleteSuccess"));
                const updatedSuperUsers = state.superUsers.filter((element) => element.userId !== superUser.userId);
                commit(mutations.setEditRequestSuccess.name);
                commit(mutations.updateSuperUsersList.name, updatedSuperUsers);
            })
            .catch((error) => {
                toast.error(error);
                commit(mutations.setEditRequestError.name, error);
            });
    }
};

const mutations = {
    setLoadingRequest(state, isLoading){
        state.isLoadingRequest = isLoading;
    },
    setSuperUsersList(state, superUsers){
        state.superUsers = superUsers;
    },
    setSuperUserEdit(state, editingSuperUser){
        state.editingSuperUser = editingSuperUser;
        state.editRequest = {
            loading: false
        };
    },
    setSuperUserEditRequestStarted(state){
        state.editRequest = {
            loading: true
        };
    },
    setEditRequestSuccess(state){
        state.editRequest = {
            loading: false,
            success: true
        };
        state.editingSuperUser = null;
    },
    setRegenerateRequest(state, { loading, message = null }){
        state.regenerateRequest = {
            loading,
            message
        };
    },
    setEditRequestError(state, errorMessage){
        state.editRequest = {
            loading: false,
            success: false,
            message: errorMessage
        };
    },
    setAddingSuperUser(state, isAdding){
        state.isAddingSuperUser = isAdding;
        if (!isAdding){
            state.addRequest = {};
        }
    },
    setAddSuperUserRequestState(state, { loading, message = null }){
        state.addRequest = {
            loading: loading,
            message: message,
        };
        if (!loading && !message){
            state.isAddingSuperUser = false;
        }
    },
    updateSuperUsersList(state, newList){
        state.superUsers = newList;
    },
    addNewSuperUser(state, newSuperUser){
        state.superUsers.push(newSuperUser);
    }
};

export const superUser = {
    namespaced: true,
    state,
    actions,
    mutations
};
